import { useQuery } from "@tanstack/react-query";
import { spbTransferAPI } from "../spbTransferAPI.ts";
import { ISbpTransferBank } from "../types.ts";

export const useGetSbpTransferBanksQuery = () => {
  return useQuery ({
    queryKey: ["sbp-transfer-banks"],
    queryFn: async (): Promise<ISbpTransferBank[]> => {
      const response = await spbTransferAPI.getBanks();
      return response.filter(bank => Boolean(bank.bankName?.trim()) && Boolean(bank.schema?.trim()));
    },
    staleTime: 60 * 60 * 1000, // 60мин
    gcTime: 60 * 60 * 1000, // 60мин
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchOnMount: true,
  });
};
